export default __webpack_public_path__ + "static/SamsungOne-800-9d762b0f303e6a2dd38ce6c58201cc19.ttf";